import {Component, ChangeDetectionStrategy} from '@angular/core';
import {AsideService} from '../../../core/services/aside.service';
import {ActivatedRoute, RouterOutlet} from '@angular/router';
import {UrlService} from '../../../core/services/url.service';
import {Store} from '@ngrx/store';
import {AppState} from '../../../app/app.state';
import {TitleChangedAction} from '../../../core/actions/title.actions';
import {BaseAppComponent} from '../_base-app/base-app.component';
import {App, AppId} from '../../../shared/models/app';
import {SessionService} from '../../../core/services/session.service';
import {PermissionsService} from '../../../core/services/permissions.service';
import {MotiChatService} from '../../../moti/services/moti-chat.service';
import {Permission} from '../../../shared/models/fga/permission';
import {ObjectType} from '../../../shared/models/object.model';
import {ObjectModel} from '../../../shared/models/object.model';

@Component({
  selector: 'motn-app-prop-manager',
  template: '<router-outlet></router-outlet>',
  styleUrls: ['./app-prop-manager.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterOutlet,
  ],
})
export class AppPropManagerComponent extends BaseAppComponent {
  app: App;
  appId: AppId;


  constructor(
    protected store: Store<AppState>,
    protected route: ActivatedRoute,
    protected session: SessionService,
    protected permissionsService: PermissionsService,
    private asideService: AsideService,
    private motiChatService: MotiChatService,
  ) {
    super(store, route, session, permissionsService);
  }


  protected onInit() {
  }


  protected onDestroy() {
  }


  protected updateTitle() {
    const subtitleItems = [];
    
    if (this.canChat) {
      subtitleItems.push({
        text: 'Chat',
        icon: 'kit:chat',
        callback: () => this.openAppChat()
      });
    }
    
    if (this.app.Config?.Subtitle?.Text) {
      subtitleItems.push({text: this.app.Config.Subtitle.Text});
    }

    this.store.dispatch(new TitleChangedAction(
      '',
      this.app.Name,
      subtitleItems,
      this.app.Config?.Location,
    ));
  }

  private openAppChat(): void {
    if (this.app) {
      this.motiChatService.openChat(this.app.ID, this.app.Name, ObjectType.APP);
    }
  }


  protected updateAside() {
    this.asideService.replaceContextSections([
      {
        name: 'Property Manager',
        items: [
          // {
          //   text: 'Dashboard',
          //   path: UrlService.makePropManagerDashboardUrl(this.appId),
          // },
          {
            text: 'Units',
            path: UrlService.makePropManagerManageUnitsUrl(this.appId),
          },
          {
            text: 'Staff',
            path: UrlService.makePropManagerStaffUrl(this.appId),
          },
        ],
        shareSubject: ObjectModel.fromApp(this.app),
      },
    ]);
  }

}
